// @flow
import * as React from 'react';

import type { ActionsContext } from '../types';

export default React.createContext<ActionsContext>({
  mergeState: unusedState => undefined,
  resetState: () => undefined,
});
